import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { AuthService } from './auth.service';
import { Router } from "@angular/router";
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  // Public endpoint reachable without a logged-in token (no auth headers,
  // no redirect to /login). Matches the exact `/melbourne-agent/signup`
  // POST — not the admin `/signup-requests` path.
  private readonly publicUrlPattern = /\/melbourne-agent\/signup(\?|$)/;

  constructor(private router: Router) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isPublic = this.publicUrlPattern.test(req.url);

    if (!isPublic && (!localStorage.getItem('_token') || localStorage.getItem('_token') == '')) {
      this.router.navigate(['/login']);
    }

    const headers: { [name: string]: string } = {
      //'Content-Type' : 'application/json; charset=utf-8',
      'Accept': 'application/json',
    };
    if (!isPublic) {
      headers['Authorization'] = `Bearer ${localStorage.getItem('_token')}`;
      headers['Access-Token'] = `Bearer ${localStorage.getItem('access_token')}`;
    }
    req = req.clone({ setHeaders: headers });
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && window.location.pathname !== '/login') {
          localStorage.removeItem('_token');
          localStorage.removeItem('access_token');
          localStorage.removeItem('user');
          window.location.href = '/login';
        }
        return throwError(error);
      })
    );
  }
}
